/**
 * Shared - Page Skeleton
 *
 * Loading skeleton component for pages
 */

import { Skeleton, SkeletonTable } from '@repo/ui';

export interface PageSkeletonProps {
  /** Show header skeleton */
  showHeader?: boolean;
  /** Show summary cards skeleton */
  showSummaryCards?: boolean;
  /** Show table skeleton */
  showTable?: boolean;
  /** Number of summary cards */
  summaryCardCount?: number;
  /** Number of table rows */
  tableRows?: number;
  /** Number of table columns */
  tableColumns?: number;
}

export function PageSkeleton({
  showHeader = true,
  showSummaryCards = true,
  showTable = true,
  summaryCardCount = 3,
  tableRows = 10,
  tableColumns = 6,
}: PageSkeletonProps) {
  return (
    <div className="space-y-6">
      {/* Header Skeleton */}
      {showHeader && (
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center space-x-3">
            <Skeleton variant="circular" width={32} height={32} />
            <Skeleton variant="text" width="400px" height="2rem" />
          </div>
          <Skeleton variant="rectangular" width="100px" height="40px" />
        </div>
      )}

      {/* Summary Cards Skeleton */}
      {showSummaryCards && (
        <div
          className={`grid grid-cols-1 ${
            summaryCardCount === 2
              ? 'md:grid-cols-2'
              : summaryCardCount === 3
                ? 'md:grid-cols-3'
                : summaryCardCount === 4
                  ? 'md:grid-cols-4'
                  : 'md:grid-cols-3'
          } gap-6 mb-6`}
        >
          {Array.from({ length: summaryCardCount }).map((_, index) => (
            <Skeleton key={index} variant="rectangular" height="120px" />
          ))}
        </div>
      )}

      {/* Table Skeleton */}
      {showTable && <SkeletonTable rows={tableRows} columns={tableColumns} />}
    </div>
  );
}

